/* popper-wrapper.tsx generated by @compiled/babel-plugin v2.0.0 */
import * as React from 'react';
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0bjKvDKxmn%7Bborder-radius%3Avar(--ds-radius-small%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3iDTPbvLZJ%7Bdisplay%3Ablock%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._24h04i2Njc%7Bbox-sizing%3Aborder-box%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._42Yu6B3fRC%7Bz-index%3A400%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0KLXruoI2d%7Bbackground-color%3Avar(--ds-surface-overlay%2C%23fff)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2OUyjtGk8v%7Bbox-shadow%3Avar(--ds-shadow-overlay%2C0%208px%209pt%20%231e1f2126%2C0%200%201px%20%231e1f214f)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1UtDYzy7kJ%7Bcolor%3Avar(--ds-text%2C%23292a2e)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._45TjwHoI2d%7B--ds-elevation-surface-current%3Avar(--ds-surface-overlay%2C%23fff)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1zr6Dc98eZ%3Afocus%7Boutline-color%3AcurrentColor%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0htemXYbGa%3Afocus%7Boutline-style%3Anone%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._067LceT6kp%3Afocus%7Boutline-width%3Amedium%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0bjKvD8fU6%7Bborder-radius%3Avar(--ds-radius-large%2C8px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._39xV02N91d%7Bwidth%3A100%25%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0NUa3rOLYo%7Bmax-height%3Ainherit%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3iDTPbQ4SZ%7Bdisplay%3Aflex%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0Tuepk1Y8M%7Binset-inline%3Avar(--ds-space-050%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0NUa3rEtrx%7Bmax-height%3Acalc(100vh%20-%20var(--ds-space-050%2C%204px)*2)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1mT5xdy1CL%7Bposition%3Afixed%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2I62gz1Y8M%7Binset-block-start%3Avar(--ds-space-050%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4bt5LAIZbP%7Boverflow-x%3Aauto%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2WAcuGIZbP%7Boverflow-y%3Aauto%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._49OCfRdnbC%7Binset%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0KLXruA5lS%7Bbackground-color%3Avar(--ds-blanket%2C%23050c1f75)%7D");
import { forwardRef, Fragment, useMemo, useState } from 'react';
import { ax, ix } from '@compiled/react/runtime';
import { useLayering } from '@atlaskit/layering/use-layering';
import { Motion, type MotionProps } from '@atlaskit/motion';
import { fg } from '@atlaskit/platform-feature-flags';
import { type Placement, Popper } from '@atlaskit/popper';
import type { CURRENT_SURFACE_CSS_VAR } from '@atlaskit/tokens/constants';
import { RepositionOnUpdate } from './reposition-on-update';
import { type PopperWrapperProps, type PopupComponentProps } from './types';
import { useCloseManager } from './use-close-manager';
import { useFocusManager } from './use-focus-manager';
const LOCAL_CURRENT_SURFACE_CSS_VAR: typeof CURRENT_SURFACE_CSS_VAR = '--ds-elevation-surface-current';
const fullWidthStyles = null;
const wrapperStyles = {
  root: "_0bjKvDKxmn _3iDTPbvLZJ _24h04i2Njc _42Yu6B3fRC _0KLXruoI2d _2OUyjtGk8v _1UtDYzy7kJ _45TjwHoI2d _1zr6Dc98eZ _0htemXYbGa _067LceT6kp",
  rootT26Shape: "_0bjKvD8fU6",
  fullWidth: "_39xV02N91d",
  motion: "_0NUa3rOLYo _3iDTPbQ4SZ"
};
const scrollableStyles = null;
const blanketStyles = null;
const modalStyles = null;
const focusRingStyles = {
  root: "_1ubuxonXvL _34b3D2vc3e _1NDpvb6wH8 _2wtOC9vc3e _3e11vU6wH8 _0hSAgbHZdu"
};
const placementMap: Record<Exclude<Placement, 'auto' | 'auto-start' | 'auto-end'>, {
  enter: MotionProps['enteringAnimation'];
  exit: MotionProps['exitingAnimation'];
}> = {
  top: {
    enter: "var(--ds-popup-enter-top, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInTop8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
    exit: "var(--ds-popup-exit-top, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutTop8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
  },
  'top-start': {
    enter: "var(--ds-popup-enter-top, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInTop8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
    exit: "var(--ds-popup-exit-top, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutTop8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
  },
  'top-end': {
    enter: "var(--ds-popup-enter-top, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInTop8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
    exit: "var(--ds-popup-exit-top, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutTop8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
  },
  bottom: {
    enter: "var(--ds-popup-enter-bottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInBottom8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
    exit: "var(--ds-popup-exit-bottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutBottom8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
  },
  'bottom-start': {
    enter: "var(--ds-popup-enter-bottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInBottom8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
    exit: "var(--ds-popup-exit-bottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutBottom8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
  },
  'bottom-end': {
    enter: "var(--ds-popup-enter-bottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInBottom8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
    exit: "var(--ds-popup-exit-bottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutBottom8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
  },
  left: {
    enter: "var(--ds-popup-enter-left, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInLeft8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
    exit: "var(--ds-popup-exit-left, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutLeft8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
  },
  'left-start': {
    enter: "var(--ds-popup-enter-left, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInLeft8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
    exit: "var(--ds-popup-exit-left, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutLeft8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
  },
  'left-end': {
    enter: "var(--ds-popup-enter-left, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInLeft8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
    exit: "var(--ds-popup-exit-left, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutLeft8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
  },
  right: {
    enter: "var(--ds-popup-enter-right, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInRight8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
    exit: "var(--ds-popup-exit-right, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutRight8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
  },
  'right-start': {
    enter: "var(--ds-popup-enter-right, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInRight8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
    exit: "var(--ds-popup-exit-right, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutRight8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
  },
  'right-end': {
    enter: "var(--ds-popup-enter-right, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInRight8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
    exit: "var(--ds-popup-exit-right, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutRight8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
  }
};
const DefaultPopupComponent: React.ForwardRefExoticComponent<React.PropsWithoutRef<PopupComponentProps> & React.RefAttributes<HTMLDivElement>> = forwardRef<HTMLDivElement, PopupComponentProps>((props, ref) => {
  const {
    shouldRenderToParent,
    shouldFitContainer,
    children,
    appearance,
    className,
    isReferenceHidden: _isReferenceHidden,
    shouldFitViewport,
    ...htmlAttributes
  } = props;
  return <div
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
  className={ax([wrapperStyles.root, fg('platform-dst-shape-theme-default') && wrapperStyles.rootT26Shape, appearance === 'UNSAFE_modal-below-sm' && "_0Tuepk1Y8M _0NUa3rEtrx _1mT5xdy1CL _2I62gz1Y8M", (!shouldRenderToParent || shouldFitViewport) && "_4bt5LAIZbP _2WAcuGIZbP", shouldFitContainer && "_39xV02N91d", className])} {...htmlAttributes} ref={!fg('platform-dst-motion-uplift-popup') ? ref : undefined}>
			{children}
		</div>;
});
function PopperWrapper({
  xcss,
  isOpen,
  id,
  offset,
  testId,
  content,
  fallbackPlacements,
  onClose,
  boundary,
  rootBoundary,
  shouldFlip,
  placement = 'auto',
  popupComponent: PopupContainer = DefaultPopupComponent,
  autoFocus = true,
  triggerRef,
  shouldUseCaptureOnOutsideClick,
  shouldIgnoreCloseEvent,
  shouldRenderToParent,
  shouldFitContainer,
  shouldDisableFocusLock,
  shouldReturnFocus = true,
  strategy,
  role,
  label,
  titleId,
  modifiers,
  shouldFitViewport,
  appearance = 'default',
  zIndex
}: PopperWrapperProps): JSX.Element {
  const [popupRef, setPopupRef] = useState<HTMLDivElement | null>(null);
  const [initialFocusRef, setInitialFocusRef] = useState<HTMLElement | null>(null);
  // We have cases where we need to close the Popup on Tab press, e.g. DropdownMenu
  const shouldCloseOnTab = shouldRenderToParent && shouldDisableFocusLock;
  const shouldDisableFocusTrap = role !== 'dialog';
  useFocusManager({
    initialFocusRef,
    popupRef,
    shouldCloseOnTab,
    triggerRef,
    autoFocus,
    shouldDisableFocusTrap,
    shouldReturnFocus
  });
  useCloseManager({
    isOpen,
    onClose,
    popupRef,
    triggerRef,
    shouldUseCaptureOnOutsideClick,
    shouldIgnoreCloseEvent,
    shouldCloseOnTab,
    autoFocus,
    shouldDisableFocusTrap,
    shouldRenderToParent
  });
  const {
    currentLevel
  } = useLayering();
  const mergedModifiers = useMemo(() => [{
    name: 'flip',
    enabled: shouldFlip,
    options: {
      rootBoundary,
      boundary,
      fallbackPlacements
    }
  }, ...(modifiers || [])], [shouldFlip, rootBoundary, boundary, fallbackPlacements, modifiers]);
  return <Popper placement={placement} offset={offset} modifiers={mergedModifiers} strategy={strategy} shouldFitViewport={shouldFitViewport}>
			{({
      ref,
      style,
      placement,
      update,
      isReferenceHidden
    }) => {
      const popupContainer = <PopupContainer
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
      className={ax([(xcss as string),
      // @ts-expect-error: `ax` is not typed correctly
      !initialFocusRef && fg('platform-design-system-apply-popup-wrapper-focus') && focusRingStyles.root])} appearance={appearance} id={id} data-ds--level={currentLevel} data-placement={placement} data-testid={testId} role={role} aria-label={label} aria-labelledby={titleId} ref={!fg('platform-dst-motion-uplift-popup') ? (node: HTMLDivElement) => {
        if (node) {
          if (typeof ref === 'function') {
            ref(node);
          } else {
            (ref as React.MutableRefObject<HTMLElement>).current = node;
          }
          setPopupRef(node);
        }
      } : undefined}
      // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
      style={fg('platform-dst-motion-uplift-popup') || appearance === 'UNSAFE_modal-below-sm' ? {} : style}
      // using tabIndex={-1} would cause a bug where Safari focuses
      // first on the browser address bar when using keyboard
      tabIndex={autoFocus ? 0 : undefined} shouldRenderToParent={shouldRenderToParent} shouldFitContainer={shouldFitContainer} shouldFitViewport={shouldFitViewport} isReferenceHidden={isReferenceHidden}>
						<RepositionOnUpdate update={update}>
							{content({
            update,
            isOpen,
            onClose,
            setInitialFocusRef
          })}
						</RepositionOnUpdate>
					</PopupContainer>;
      const isAutoPlacement = placement === 'auto' || placement === 'auto-start' || placement === 'auto-end';
      const container = <div
      // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
      style={{
        ...style,
        zIndex
      }}
      // using tabIndex={-1} would cause a bug where Safari focuses
      // first on the browser address bar when using keyboard
      ref={(node: HTMLDivElement) => {
        if (node) {
          if (typeof ref === 'function') {
            ref(node);
          } else {
            (ref as React.MutableRefObject<HTMLElement>).current = node;
          }
          setPopupRef(node);
        }
      }} data-testid={`${testId}--container`} className={ax([shouldFitContainer && wrapperStyles.fullWidth])}>
						{/* Don't apply motion to auto placements */}

						<Motion enteringAnimation={!isAutoPlacement ? placementMap[placement].enter : undefined} exitingAnimation={!isAutoPlacement ? placementMap[placement].exit : undefined} xcss={wrapperStyles.motion}>
							{popupContainer}
						</Motion>
					</div>;
      return <Fragment>
						{fg('platform-dst-motion-uplift-popup') ? container : popupContainer}
						{appearance === 'UNSAFE_modal-below-sm' && <div className={ax(["_49OCfRdnbC _1mT5xdy1CL _0KLXruA5lS"])} />}
					</Fragment>;
    }}
		</Popper>;
}

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export default PopperWrapper;